export var AUTO_OPEN_ADD_MEMBER_QUERY_STRING = 'addMember';
export var MAX_GROUPS_COUNT = 250; // This is a discussed limit with BE, since we don't support pagination in the UI.
